import React, { useRef } from "react";
import Slider from "react-slick";
import Badge from "../../shared/badge";
import { Icon } from "@iconify/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";

const Testimonials = () => {
  const { t } = useTranslation();
  const sliderRef = useRef(null);

  const handleNext = () => {
    sliderRef.current.slickNext();
  };

  const handlePrev = () => {
    sliderRef.current.slickPrev();
  };
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: null,
    prevArrow: null,
    responsive: [
      {
        breakpoint: 1480, // For tablets
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024, // For tablets
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // For mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="testimonials-main w-100 pb-[199px] sm-s:pb-[70px]">
        <div className="testimonials-inner w-[80%] m-auto max-xxxl:w-[90%]">
          <Badge txt={t("aboutUs.testimonials.title")} />
          <div className="mt-[20px] flex justify-between items-end ">
            <h2 className="max-w-[528px]  leading-[70px] tracking-[-3px] font-sora">
              {t("aboutUs.testimonials.subtitle")}
            </h2>
            <div className="flex w-fit items-center gap-[40px] mr-[20px] sm-s:hidden">
              <img
                src="../../assets/icons/arrowLeft.png"
                alt="leftarrow"
                onClick={handlePrev}
                className="cursor-pointer drop-shadow-md"
              />

              <img
                src="../../assets/icons/arrowRight.png"
                alt="leftarrow"
                onClick={handleNext}
                className="cursor-pointer drop-shadow-md"
              />
            </div>
          </div>

          {/* Carousel */}
          <div className="testimonial-wrapper mt-[89px] sm-s:mt-[49px]">
            <Slider {...settings} ref={sliderRef}>
              {[1, 2, 3, 4, 5].map((_, index) => (
                <div key={index} className="testimonial-card drop-shadow-xl !w-[92%] h-[407px] ">
                  <img
                    src="../../assets/images/about/testimonial-back.png"
                    alt="background"
                    className="absolute z-[-1] w-full h-full"
                  />
                  <div className="content flex flex-col items-center px-[16px] w-full">
                    <div className="flex items-center mb-[34px] mt-[15px]">
                      {Array(5)
                        .fill()
                        .map((_, idx) => (
                          <Icon
                            key={idx}
                            icon="material-symbols:star"
                            width={26}
                            height={26}
                            color="#E7B025"
                          />
                        ))}
                    </div>
                    <img src="../../assets/images/about/testimonial-user.png" alt="user" />
                    <h6 className="font-bold text-blue leading-[20px] mt-[12px]">
                      {t("aboutUs.testimonials.review.one.title")}
                    </h6>
                    <p className="font-medium large txt-color leading-[18px] mt-[8px]">
                      {t("aboutUs.testimonials.review.one.subtitle")}
                    </p>
                    <p className="large txt-color leading-[18px] mt-[26px] max-w-[378px] text-center">
                      {t("aboutUs.testimonials.review.one.desc")}
                    </p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
        <div className="m-auto w-100 hidden justify-center mt-[20px] sm-s:flex">
          <div className="flex w-fit items-center justify-center gap-[40px] mr-[20px]">
            <img
              src="../../assets/icons/arrowLeft.png"
              alt="leftarrow"
              onClick={handlePrev}
              className="cursor-pointer drop-shadow-md"
            />

            <img
              src="../../assets/icons/arrowRight.png"
              alt="leftarrow"
              onClick={handleNext}
              className="cursor-pointer drop-shadow-md"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Testimonials;
